import Content from "../../help/material-list.mdx";

export function MaterialListHelpPage() {
  return <Content />;
}
